import { Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Loginservices } from 'src/app/login/login.services';

@Component({
  selector: 'app-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.css']
})
export class OtpInputComponent {
   @Input() length = 6;
  @Output() otpCompleted = new EventEmitter<string>();
  @ViewChildren('otpBox') otpBoxes!: QueryList<ElementRef>;
  // otp: string[] = ["", "", "", "","",""];
  otp=""
  otpArray = new Array(6);
  userid='';
  otpinputclass='otp-box'
ivalidotp=false
  constructor(private ref:DynamicDialogRef,private loginservice:Loginservices,private config:DynamicDialogConfig,private spinner:NgxSpinnerService){
    const dataFromParent = this.config.data;
    console.log(dataFromParent,"from parent");
    this.userid=dataFromParent.fromvalue.userid

  }

// onInput(event: any, index: number) {  
//   this.ivalidotp=false;
//    this.otpinputclass="otp-box"
//   const input = event.target;
//   const value = input.value.replace(/[^0-9]/g, '');
//   this.otp[index] = value;

//   if (value && index < this.otpArray.length - 1) {
//     const next = document.querySelectorAll('.otp-box')[index + 1] as HTMLInputElement;
//     next.focus();
//   }
// }

onKeyDown(event: KeyboardEvent, index: number) {
  this.ivalidotp=false;
   this.otpinputclass="otp-box"
  if (event.key === "Backspace" && !this.otp[index] && index > 0) {
    const prev = document.querySelectorAll('.'+this.otpinputclass)[index - 1] as HTMLInputElement;
    prev.focus();
  }
}
// onPaste(event: ClipboardEvent) {
//   event.preventDefault();

//   const pastedData = event.clipboardData?.getData('text') ?? '';
//   const digits = pastedData.replace(/\D/g, '').split('');

//   if (digits.length === 0) return;

//   this.otp = this.otp.map((_, i) => digits[i] ?? '');

//   // Focus last filled box
//   const lastIndex = Math.min(digits.length - 1, this.otpArray.length - 1);
//   const inputs = document.querySelectorAll('.otp-box') as NodeListOf<HTMLInputElement>;
//   inputs[lastIndex].focus();
// }


verifyOTP(){
  const submittedOTP = this.otp;
const payload={
  mfaenteredotp:submittedOTP,
  userid:this.userid
}
this.spinner.show();
this.loginservice.verifymfaotp(payload).subscribe(res=>{
  this.spinner.hide()
  if(res.message=='success'){
    this.ref.close('validotp')
    this.ivalidotp=false
  }
  else{
  this.ivalidotp=true
    this.otpinputclass="otp-box-invalid"
  }
},error=>{
    this.ivalidotp=true
    this.otpinputclass="otp-box-invalid"
      setTimeout(() => {this.ivalidotp = false,
       this.otpinputclass='otp-box'}, 300); // reset animation

})

// this.ref.close('validotp')
}
onclose(){
  this.ref.close()
}
}
